"use strict";
exports.__esModule = true;
var Fxp = window['Fxp'] || {};
var fxpComponentRegistrationService = null;
var partnerAppRegistrationService = null;
var adminLandingService = null;
var dashboardService = null;
var fxpAuthorizationService = null;
var fxpBreadcrumbService = null;
var userProfileService = null;
var userClaimsService = null;
var adalLoginHelperService = null;
var fxpMessageService = null;
var notificationStore = null;
var fxpConfigurationService = null;
var fxpFeedbackService = null;
var fxpRouteService = null;
var fxpStorageService = null;
var fxpToastNotificationService = null;
var helpCentralService = null;
var notificationActionCenter = null;
var notificationService = null;
var oBOUserService = null;
var pageLoaderService = null;
var pageTourEventService = null;
var personalizationService = null;
var plannedDownTimeService = null;
var systemMessagesService = null;
var timeZoneHelper = null;
var userInfoService = null;
var fxpBotService = null;
var fxpBotServiceProvider = null;

var businessProcessEvent = null;
var featureUsageEvent = null;
var systemEvent = null;
var componentType = null;
var environmentData = null;
var eventData = null;
var eventTypes = null;
var environment = null;
var fxpBroadcastedEvents = null;
var fxpLoggerService = null;
var fxpLoggerServiceExtension = null;
var telemetryConfiguration = null;
var userInfo = null;
var telemetryContext = null;
var fxpLoggingStrategyFactory = null;
var fxpOnlineLoggingStrategy = null;
var fxpHttpService = null;
var authorNotificationConstant = null;
var createAskOpsModalConstant = null;
var helpArticleImageModalConstant = null;
var sessionTimeoutModalConstant = null;
var SYSTEM_MESSAGE_UI = null;
var fxpEventBroadCastService = null;
var fxpIrisBotService = null;
var confitService = null;
var featureFlagService = null;
var fxpUIData = null;
var deviceFactoryProvider = null;
var fxpConstants = null;
var settingsServiceProvider = null;
var fxpContext = null;
var fxpPartnerHttpInterceptorHooks = null;
var fxpGlobalStoreService = null;
var fxpOCVFeedbackService = null
var fxpSignalRService = null;
var errorSeverityLevel = null;
var fxpTelemActionType = null;
var fxpTelemEventName = null;
var fxpTelemActionStatus = null;
var commonUtils = null;
var componentFramework = null; 
var fxpTelemGuid =  null;
if (Fxp && Fxp.Utils && Fxp.Utils.Services) {
    deviceFactoryProvider = Fxp.Utils.DeviceFactoryProvider;
    adalLoginHelperService = Fxp.Utils.Services.AdalLoginHelperService;
    commonUtils = Fxp.Utils.CommonUtils; 
}
if(Fxp && Fxp.Factory){
    fxpUIData = Fxp.Factory.FxpUIData;
}
if(Fxp && Fxp.Common){
    fxpConstants = Fxp.Common.Constants.FxpConstants;
    environment = Fxp.Common.Environment;
    componentFramework = Fxp.Common.ComponentFramework;
}

if (Fxp && Fxp.Services) {
    fxpComponentRegistrationService = Fxp.Services.FxpComponentRegistrationService;
    partnerAppRegistrationService = Fxp.Services.PartnerAppRegistrationService;
    userProfileService = Fxp.Services.UserProfileService;
    userClaimsService = Fxp.Services.UserClaimsService;
    fxpMessageService = Fxp.Services.FxpMessageService;
    fxpEventBroadCastService = Fxp.Services.FxpEventBroadCastService;
	fxpIrisBotService = Fxp.Services.FxpIrisBotService;
    fxpHttpService = Fxp.Services.FxpHttpService;
    notificationStore = Fxp.Services.NotificationStore;
    adminLandingService = Fxp.Services.AdminLandingService;
    dashboardService = Fxp.Services.DashboardService;
    fxpAuthorizationService = Fxp.Services.FxpAuthorizationService;
    fxpBreadcrumbService = Fxp.Services.FxpBreadcrumbService;
    fxpConfigurationService = Fxp.Services.FxpConfigurationService;
    fxpFeedbackService = Fxp.Services.FxpFeedbackService;
    fxpRouteService = Fxp.Services.FxpRouteService;
    fxpStorageService = Fxp.Services.FxpStorageService;
    fxpToastNotificationService = Fxp.Services.FxpToastNotificationService;
    helpCentralService = Fxp.Services.HelpCentralService;
    notificationActionCenter = Fxp.Services.NotificationActionCenter;
    notificationService = Fxp.Services.NotificationService;
    oBOUserService = Fxp.Services.OBOUserService;
    pageLoaderService = Fxp.Services.PageLoaderService;
    pageTourEventService = Fxp.Services.PageTourEventServiceAlias;
    personalizationService = Fxp.Services.PersonalizationService;
    plannedDownTimeService = Fxp.Services.PlannedDownTimeService;
    systemMessagesService = Fxp.Services.SystemMessagesService;
    timeZoneHelper = Fxp.Services.TimeZoneHelper;
    userInfoService = Fxp.Services.UserInfoService;
    fxpBotService = Fxp.Services.FxpBotService;
    fxpBotServiceProvider = Fxp.Services.FxpBotServiceProvider;
    settingsServiceProvider = Fxp.Services.SettingsServiceProvider;

    businessProcessEvent = Fxp.Telemetry.BusinessProcessEvent;
    featureUsageEvent = Fxp.Telemetry.FeatureUsageEvent;
    fxpTelemGuid =  Fxp.Telemetry.FxpTelemGuid;
    systemEvent = Fxp.Telemetry.SystemEvent;
    componentType = Fxp.Telemetry.ComponentType;
    errorSeverityLevel = Fxp.Telemetry.ErrorSeverityLevel;
    fxpTelemActionType = Fxp.Telemetry.FxpTelemActionType;
    fxpTelemEventName = Fxp.Telemetry.FxpTelemEventName;
    fxpTelemActionStatus = Fxp.Telemetry.FxpTelemActionStatus;
    environmentData = Fxp.Telemetry.EnvironmentData;
    eventData = Fxp.Telemetry.EventData;
    eventTypes = Fxp.Telemetry.EventTypes;
    fxpBroadcastedEvents = Fxp.Services.FxpBroadcastedEvents;
    fxpLoggerService = Fxp.Telemetry.FxpLoggerService;
    fxpLoggerServiceExtension = Fxp.Telemetry.FxpLoggerServiceExtension;
    telemetryConfiguration = Fxp.Telemetry.TelemetryConfiguration;
    userInfo = Fxp.Telemetry.UserInfo;
    telemetryContext = Fxp.Telemetry.TelemetryContext;
    fxpLoggingStrategyFactory = Fxp.Telemetry.FxpLoggingStrategyFactory;
    fxpOnlineLoggingStrategy = Fxp.Telemetry.FxpOnlineLoggingStrategy;
    authorNotificationConstant = Fxp.Constants.AuthorNotificationConstant;
    createAskOpsModalConstant = Fxp.Constants.createAskOpsModalConstant;
    helpArticleImageModalConstant = Fxp.Constants.HelpArticleImageModalConstant;
    sessionTimeoutModalConstant = Fxp.Constants.SessionTimeoutModalConstant;
    SYSTEM_MESSAGE_UI = Fxp.Constants.SYSTEM_MESSAGE_UI;
    confitService = Fxp.Services.ConFitService;
    featureFlagService = Fxp.Services.FeatureFlagService;
    fxpPartnerHttpInterceptorHooks = Fxp.Services.FxpPartnerHttpInterceptorHooks;
    fxpGlobalStoreService = Fxp.Services.FxpGlobalStoreService;
    fxpOCVFeedbackService = Fxp.Services.FxpOCVFeedbackService;
    fxpSignalRService = Fxp.Services.FxpSignalRService;

}
if (Fxp && Fxp.Context){
    fxpContext = Fxp.Context.FxpContext;
}
exports.Fxp = Fxp;
exports.AuthorNotificationConstant = authorNotificationConstant;
exports.CreateAskOpsModalConstant = createAskOpsModalConstant;
exports.HelpArticleImageModalConstant = helpArticleImageModalConstant;
exports.SessionTimeoutModalConstant = sessionTimeoutModalConstant;
exports.SYSTEM_MESSAGE_UI = SYSTEM_MESSAGE_UI;
exports.FxpComponentRegistrationService = fxpComponentRegistrationService;
exports.PartnerAppRegistrationService = partnerAppRegistrationService;
exports.UserProfileService = userProfileService;
exports.UserClaimsService = userClaimsService;
exports.FxpMessageService = fxpMessageService;
exports.FxpBroadcastedEvents = fxpBroadcastedEvents;
exports.FxpEventBroadCastService = fxpEventBroadCastService;
exports.FxpIrisBotService = fxpIrisBotService;
exports.FxpHttpService = fxpHttpService;
exports.NotificationStore = notificationStore;
exports.AdalLoginHelperService = adalLoginHelperService;
exports.AdminLandingService = adminLandingService;
exports.DashboardService = dashboardService;
exports.FxpAuthorizationService = fxpAuthorizationService;
exports.FxpBreadcrumbService = fxpBreadcrumbService;
exports.FxpConfigurationService = fxpConfigurationService;
exports.FxpFeedbackService = fxpFeedbackService;
exports.FxpRouteService = fxpRouteService;
exports.FxpStorageService = fxpStorageService;
exports.FxpToastNotificationService = fxpToastNotificationService;
exports.HelpCentralService = helpCentralService;
exports.NotificationActionCenter = notificationActionCenter;
exports.NotificationService = notificationService;
exports.OBOUserService = oBOUserService;
exports.PageLoaderService = pageLoaderService;
exports.pageTourEventService = pageTourEventService;
exports.PersonalizationService = personalizationService;
exports.PlannedDownTimeService = plannedDownTimeService;
exports.SystemMessagesService = systemMessagesService;
exports.TimeZoneHelper = timeZoneHelper;
exports.UserInfoService = userInfoService;
exports.FxpBotService = fxpBotService;
exports.FxpBotServiceProvider = fxpBotServiceProvider;
exports.BusinessProcessEvent = businessProcessEvent;
exports.FeatureUsageEvent = featureUsageEvent;
exports.FxpTelemGuid = fxpTelemGuid;
exports.SystemEvent = systemEvent;
exports.ComponentType = componentType;
exports.ErrorSeverityLevel = errorSeverityLevel;
exports.FxpTelemActionType = fxpTelemActionType;
exports.FxpTelemEventName = fxpTelemEventName;
exports.FxpTelemActionStatus = fxpTelemActionStatus;
exports.EnvironmentData = environmentData;
exports.EventData = eventData;
exports.EventTypes = eventTypes;
exports.FxpLoggerService = fxpLoggerService;
exports.FxpLoggerServiceExtension = fxpLoggerServiceExtension;
exports.TelemetryConfiguration = telemetryConfiguration;
exports.UserInfo = userInfo;
exports.TelemetryContext = telemetryContext;
exports.FxpLoggingStrategyFactory = fxpLoggingStrategyFactory;
exports.FxpOnlineLoggingStrategy = fxpOnlineLoggingStrategy;
exports.ConFitService = confitService;
exports.FeatureFlagService = featureFlagService;
exports.FxpUIData = fxpUIData;
exports.DeviceFactoryProvider = deviceFactoryProvider;
exports.FxpConstants = fxpConstants;
exports.SettingsServiceProvider = settingsServiceProvider;
exports.Environment = environment;
exports.FxpContext = fxpContext;
exports.FxpPartnerHttpInterceptorHooks = fxpPartnerHttpInterceptorHooks;
exports.FxpGlobalStoreService = fxpGlobalStoreService;
exports.FxpSignalRService = fxpSignalRService;
exports.FxpGlobalStoreService = fxpGlobalStoreService;
exports.FxpOCVFeedbackService = fxpOCVFeedbackService;
exports.CommonUtils = commonUtils;
exports.ComponentFramework = componentFramework;


exports.StorageType = exports.ItEventType = exports.ActionType = exports.EventName = exports.ComponentType = exports.FxpTelemActionType = exports.FxpTelemEventName = exports.FxpTelemActionStatus = void 0;
var ComponentType;
(function (ComponentType) {
    ComponentType[ComponentType["Web"] = 0] = "Web";
    ComponentType[ComponentType["SmartApp"] = 1] = "SmartApp";
    ComponentType[ComponentType["Device"] = 2] = "Device";
    ComponentType[ComponentType["BackgroundProcess"] = 3] = "BackgroundProcess";
    ComponentType[ComponentType["WebService"] = 4] = "WebService";
    ComponentType[ComponentType["Executable"] = 5] = "Executable";
    ComponentType[ComponentType["DynamicLinkLibrary"] = 6] = "DynamicLinkLibrary";
    ComponentType[ComponentType["JobService"] = 7] = "JobService";
    ComponentType[ComponentType["WorkflowComponent"] = 8] = "WorkflowComponent";
    ComponentType[ComponentType["DataStore"] = 9] = "DataStore";
    ComponentType[ComponentType["Other"] = 10] = "Other";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var EventName;
(function (EventName) {
    EventName["PageLoad"] = "PageLoad";
    EventName["DropdownSelected"] = "DropdownSelected";
    EventName["DropdownChange"] = "DropdownChange";
    EventName["PageNavigation"] = "PageNavigation";
    EventName["CheckboxChange"] = "CheckboxChange";
    EventName["ListChange"] = "ListChange";
    EventName["ButtonClick"] = "ButtonClick";
    EventName["TabChange"] = "TabChange";
    EventName["TabNavigation"] = "TabNavigation";
    EventName["PanelOpened"] = "PanelOpened";
    EventName["PanelClosed"] = "PanelClosed";
    EventName["PickerSelected"] = "PickerSelected";
    EventName["PickerDeselected"] = "PickerDeselected";
    EventName["TileAdded"] = "TileAdded";
    EventName["TileClicked"] = "TileClicked";
    EventName["TileDeleted"] = "TileDeleted";
    EventName["TileLoaded"] = "TileLoaded";
    EventName["OnFocus"] = "OnFocus";
    EventName["OnBlur"] = "OnBlur";
    EventName["TextChange"] = "TextChange";
    EventName["Scroll"] = "Scroll";
    EventName["SectionRendering"] = "SectionRendering";
    EventName["BackEndAPICall"] = "BackEndAPICall";
    EventName["Rendering"] = "Rendering";
    EventName["NA"] = "NA";
    EventName["Hover"] = "Hover";
    EventName["LinkClicked"] = "LinkClicked";
})(EventName = exports.EventName || (exports.EventName = {}));
var ActionType;
(function (ActionType) {
    ActionType["User"] = "User";
    ActionType["System"] = "System";
    ActionType["Aware"] = "Aware";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var ItEventType;
(function (ItEventType) {
    ItEventType[ItEventType["FeatureUsageEvent"] = 0] = "FeatureUsageEvent";
    ItEventType[ItEventType["BusinessProcessEvent"] = 1] = "BusinessProcessEvent";
    ItEventType[ItEventType["BusinessEventMessageExchange"] = 2] = "BusinessEventMessageExchange";
    ItEventType[ItEventType["BusinessEventEntityUpdate"] = 3] = "BusinessEventEntityUpdate";
    ItEventType[ItEventType["BusinessEventDatabaseRecord"] = 4] = "BusinessEventDatabaseRecord";
    ItEventType[ItEventType["SystemEvent"] = 5] = "SystemEvent";
    ItEventType[ItEventType["Other"] = 6] = "Other";
})(ItEventType = exports.ItEventType || (exports.ItEventType = {}));
var StorageType;
(function (StorageType) {
    StorageType[StorageType["LocalStorage"] = 0] = "LocalStorage";
    StorageType[StorageType["SessionStorage"] = 1] = "SessionStorage";
})(StorageType = exports.StorageType || (exports.StorageType = {}));
var FxpTelemActionType;
(function (FxpTelemActionType) {
    FxpTelemActionType["User"] = "User";
    FxpTelemActionType["System"] = "System";
    FxpTelemActionType["Aware"] = "Aware";
})(FxpTelemActionType = exports.FxpTelemActionType || (exports.FxpTelemActionType = {}));
var FxpTelemEventName;
(function (FxpTelemEventName) {
    FxpTelemEventName["PageLoad"] = "PageLoad";
    FxpTelemEventName["DropdownSelected"] = "DropdownSelected";
    FxpTelemEventName["DropdownChange"] = "DropdownChange";
    FxpTelemEventName["PageNavigation"] = "PageNavigation";
    FxpTelemEventName["CheckboxChange"] = "CheckboxChange";
    FxpTelemEventName["ListChange"] = "ListChange";
    FxpTelemEventName["ButtonClick"] = "ButtonClick";
    FxpTelemEventName["TabChange"] = "TabChange";
    FxpTelemEventName["TabNavigation"] = "TabNavigation";
    FxpTelemEventName["PanelOpened"] = "PanelOpened";
    FxpTelemEventName["PanelClosed"] = "PanelClosed";
    FxpTelemEventName["PickerSelected"] = "PickerSelected";
    FxpTelemEventName["PickerDeselected"] = "PickerDeselected";
    FxpTelemEventName["TileAdded"] = "TileAdded";
    FxpTelemEventName["TileClicked"] = "TileClicked";
    FxpTelemEventName["TileDeleted"] = "TileDeleted";
    FxpTelemEventName["TileLoaded"] = "TileLoaded";
    FxpTelemEventName["OnFocus"] = "OnFocus";
    FxpTelemEventName["OnBlur"] = "OnBlur";
    FxpTelemEventName["TextChange"] = "TextChange";
    FxpTelemEventName["Scroll"] = "Scroll";
    FxpTelemEventName["SectionRendering"] = "SectionRendering";
    FxpTelemEventName["BackEndAPICall"] = "BackEndAPICall";
    FxpTelemEventName["Rendering"] = "Rendering";
    FxpTelemEventName["NA"] = "NA";
    FxpTelemEventName["Hover"] = "Hover";
    FxpTelemEventName["LinkClicked"] = "LinkClicked";
})(FxpTelemEventName = exports.FxpTelemEventName || (exports.FxpTelemEventName = {}));

var FxpTelemActionStatus;
(function (FxpTelemActionStatus) {
    FxpTelemActionStatus["Succeeded"] = "Succeeded";
    FxpTelemActionStatus["Failed"] = "Failed";
    FxpTelemActionStatus["NA"] = "NA";
})(FxpTelemActionStatus = exports.FxpTelemActionStatus || (exports.FxpTelemActionStatus = {}));